import React from 'react';
import { Grid } from '@mui/material';

import { InfoField } from '@occc/ui-design-system';
import { MembershipFragment } from '@occc/graphql';

type MemberExternalIdFieldsProps = {
  externalLoyaltyIds: MembershipFragment['externalLoyaltyIds'];
};

const MemberExternalIdFields = ({ externalLoyaltyIds }: MemberExternalIdFieldsProps) => {
  return (
    <>
      {externalLoyaltyIds.map((externalId) => (
        <Grid item xs={12} md={3} key={externalId.id}>
          <InfoField
            label={externalId.externalProgram.name}
            value={externalId.identifier}
            sx={{ overflowWrap: 'anywhere' }}
          />
        </Grid>
      ))}
    </>
  );
};

export default MemberExternalIdFields;
